import './ratingsHighsLows.scss';



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/RatingsHighsLows/index.js